import { render } from "./EditorModalLink.vue?vue&type=template&id=1855d270&ts=true"
import script from "./EditorModalLink.vue?vue&type=script&lang=ts"
export * from "./EditorModalLink.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__